import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-change-forget-password',
  templateUrl: './change-forget-password.component.html',
  styleUrls: ['./change-forget-password.component.css']
})
export class ChangeForgetPasswordComponent implements OnInit {
  token:string
  guid:string
  isLinkValid:boolean
  isSavingData:boolean
  constructor(private authService:AuthService,private activatedRoute:ActivatedRoute,private toasterService:ToastrService,private router:Router) {
    this.token=this.activatedRoute.snapshot.queryParams["token"]
    this.guid=this.activatedRoute.snapshot.queryParams["guid"]
    if(!this.token || !this.guid) this.router.navigate(["/"])
    else this.checkPasswordResetLinkValidity()
  }

  ngOnInit() {
  }
  checkPasswordResetLinkValidity(){
    this.authService.checkPasswordResetLinkValidity({token:this.token,guid:this.guid}).subscribe(
      (response:any)=>{
        console.log(response)
        if(response.error) this.isLinkValid=false
        else this.isLinkValid=true
      },
      (error:any)=>{this.isLinkValid=false}
    )
  }
  resetPassword(form){
    this.isSavingData=true
    if(form.invalid) return
    const detail={
      newPassword:form.value.newPassword,
      confirmPassword:form.value.confirmPassword,
      token:this.token,
      guid:this.guid
    }
    this.authService.resetOrgPassword(detail).subscribe(
      (response:any)=>{
        if(!response.error){
          this.toasterService.success("Password updated successfully")
          this.router.navigate(["/"])
        }
        else this.toasterService.error(response.message)
        this.isSavingData=false
      },
      (error)=>{
        this.isSavingData=false
        this.toasterService.error(error.error.message)
      }
    )
  }
  home(){
    this.router.navigateByUrl("/")
  }
}
